import {useTheme} from 'styled-components';
import {ServicePointHoursProps} from '../types';

import {useState} from 'react';
import {
	getCurrentServicePointHour,
	getServicePointStatus,
	getStatusColor,
	getStatusDetail,
	getStatusLabel,
} from '../utils';

export function useServicePointHours({hours}: ServicePointHoursProps) {
	const theme = useTheme();
	const [expandedState, setExpandedState] = useState(false);

	const now = new Date();
	const currentHour = getCurrentServicePointHour(hours, now);
	const status = getServicePointStatus(currentHour, now);
	const statusLabel = getStatusLabel(status);
	const statusColor = getStatusColor(status, theme);
	const statusDetail = getStatusDetail(status, currentHour, now);

	const isOpen = status === 'open' || status === 'closing-soon';

	const handleExpandClick = () => {
		setExpandedState(previousState => !previousState);
	};

	return {
		theme,
		expandedState,
		setExpandedState,
		currentHour,
		isOpen,
		statusLabel,
		statusColor,
		statusDetail,
		handleExpandClick,
	};
}
